<h4 class="chartTitle">{{ chartTitle() }}</h4>
<div class="columnChartDiv" [id]="chartdiv_id"></div>
